export class ContentCardModel {
  id: string;
  bannerImage: string;
  titleTH: string;

  constructor(id: string, bannerImage: string, titleTH: string) {
    this.id = id;
    this.bannerImage = encodeURI(bannerImage);
    this.titleTH = titleTH;
  }
}
